import React from 'react'
import { Link } from 'react-router-dom'
import { SearchNormal1 } from 'iconsax-react';
import { FaFileInvoice } from "react-icons/fa6";


const CareerSection = () => {
  return (
    <section className='role__section padding__tb__100'>
        <div className='container'>
            <div className='row'>
            <div className='col-12 col-lg-12'>
                <h2 className='role__section__heading'>Open Roles</h2>
                <p className='role__section__content'>
                Check out our current opportunities and find your fit in product development, engineering, customer success, and more.
                </p>
                <div className="position-relative my-3">
                <form className="d-flex align-items-center rounded-pill border px-3 py-1 bg-white mx-auto" style={{ maxWidth: "500px" }}>
                    <SearchNormal1 className="me-2" color="#6c757d" />
                    <input type="search" name="search" placeholder="Search for articles" className="form-control border-0 shadow-none" style={{ flex: 1 }} />
                    <button type="submit" className="btn btn-dark btn-sm rounded-pill px-3" style={{ backgroundColor: "#2A0A7D"}}> Search </button>
                </form>
                </div>
                <div className='d-flex gap-3 justify-content-center align-items-center mt-4'>
                <Link to='/careers/frontend-developer' className='open__role__button'><span className='icon'><FaFileInvoice /></span> Frontend Developer</Link>
                <Link to='/careers/frontend-developer' className='open__role__button'><span className='icon'><FaFileInvoice /></span> Backend Developer</Link>
                <Link to='/careers/frontend-developer' className='open__role__button'><span className='icon'><FaFileInvoice /></span> Social Media Manager</Link>
                </div>
            </div>
            </div>
        </div>
    </section>
  )
}

export default CareerSection